import { render } from "./MenuPageShimmer.vue?vue&type=template&id=f5318e1e"
import script from "./MenuPageShimmer.vue?vue&type=script&lang=js"
export * from "./MenuPageShimmer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__